const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL
  || (process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : '');

export async function subscribeToMailerLite(email, bookId) {
  const response = await fetch(`${BACKEND_BASE_URL}/api/subscribe`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, bookId }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Subscription failed.');
  }

  return response.json();
}

export async function fetchSubscriptionStatus() {
  const response = await fetch(`${BACKEND_BASE_URL}/api/subscription-status`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Could not load subscription status.');
  }

  return response.json();
}

export async function fetchSampleEpub(bookId) {
  const response = await fetch(`${BACKEND_BASE_URL}/api/sample/${bookId}`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Unable to load sample.');
  }

  return response.blob();
}
